var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { BehaviorSubject, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import produce from 'immer';
import { Model } from './Model';
import { NotExistError } from "./errors";
var INITIAL_META_DATA = {
    loading: false,
    done: false,
    error: null
};
var AsyncModel = /** @class */ (function (_super) {
    __extends(AsyncModel, _super);
    function AsyncModel(proxy, initialValue) {
        var _this = _super.call(this, initialValue) || this;
        _this.proxy = proxy;
        _this.metaSubject = new BehaviorSubject(INITIAL_META_DATA);
        _this.loadSubscription = null;
        _this.meta = INITIAL_META_DATA;
        return _this;
    }
    AsyncModel.prototype.getValue = function () {
        return _super.prototype.getValue.call(this);
    };
    AsyncModel.prototype.getMeta = function () {
        return __assign({}, this.meta);
    };
    AsyncModel.prototype.getMetaAsObservable = function () {
        return this.metaSubject.asObservable();
    };
    AsyncModel.prototype.asObservable = function () {
        var _this = this;
        return merge(_super.prototype.asObservable.call(this), this.getMetaAsObservable().pipe(map(function () { return _this.getValue(); })));
    };
    AsyncModel.prototype.load = function (params, filterQuery) {
        var _this = this;
        if (this.loadSubscription) {
            this.loadSubscription.unsubscribe();
        }
        this.updateMeta(function (meta) {
            meta.loading = true;
        });
        return new Promise(function (resolve, reject) {
            if (!_this.proxy) {
                throw new Error('AsyncModel error: You must create async model with proxy');
            }
            _this.loadSubscription = _this.proxy.load(null, params, filterQuery).subscribe(function (_a) {
                var data = _a.data, meta = _a.meta;
                try {
                    if (data) {
                        _this.setValue(data);
                    }
                    _this.updateMeta(function (prevMeta) {
                        prevMeta.loading = false;
                        prevMeta.done = true;
                        prevMeta.error = null;
                        prevMeta.totalCount = meta.totalCount;
                    });
                    if (!data) {
                        _this.updateMeta(function (prevMeta) {
                            prevMeta.error = NotExistError;
                        });
                        resolve();
                        return;
                    }
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            }, function (err) {
                _this.updateMeta(function (meta) {
                    meta.loading = false;
                    meta.error = err;
                });
                reject(err);
            });
        });
    };
    AsyncModel.prototype.unsubscribe = function () {
        if (this.loadSubscription) {
            this.loadSubscription.unsubscribe();
        }
    };
    AsyncModel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.metaSubject.complete();
        this.unsubscribe();
    };
    AsyncModel.prototype.updateMeta = function (updater) {
        this.meta = produce(this.meta, updater);
        this.metaSubject.next(this.meta);
    };
    return AsyncModel;
}(Model));
export { AsyncModel };
//# sourceMappingURL=AsyncModel.js.map